import React, { memo } from 'react'
import {
  Rows,
  Columns,
  LinkInternal,
  LinkExternal,
  Heading,
  BoxLinkExternal,
  ContentSmall,
  Box,
  TwitterIcon,
  FacebookIcon,
  Logo,
} from '../../design-system'
import { Section, PartnerGrid } from '../atoms'
import { ScrollLink } from './scroll-link'
import { ThemeProvider } from 'emotion-theming'
import { darkTheme2019 } from '../theme'
import {
  MomentumLogo,
  CWULogo,
  BALogo,
  NNULogo,
  DCLogo,
  GJNLogo,
  WOWLogo,
  AutonomyLogo,
  CommonwealthLogo,
  RosaLogo,
  IWGBLogo,
  NMLogo,
  PlutoLogo,
  VersoLogo,
} from '../graphics'

export const PageFooter2019 = memo(() => (
  <ThemeProvider theme={darkTheme2019}>
    <Section bg="dark" color="content" wide>
      <Rows spacing={4}>
        <Rows spacing={2}>
          <Heading level={2} variant="headingSmall">
            Partners
          </Heading>
          <PartnerGrid gap={3} columnSize={200}>
            <BoxLinkExternal href="https://peoplesmomentum.com/">
              <MomentumLogo />
            </BoxLinkExternal>
            <BoxLinkExternal href="https://www.cwu.org/">
              <CWULogo />
            </BoxLinkExternal>
            <BoxLinkExternal href="https://www.amielandmelburn.org.uk/">
              <BALogo />
            </BoxLinkExternal>
          </PartnerGrid>
        </Rows>
        <Rows spacing={2}>
          <PartnerGrid gap={3} columnSize={50} maxColumnSize={150}>
            <BoxLinkExternal href="https://www.nationalnursesunited.org/">
              <NNULogo />
            </BoxLinkExternal>
            <BoxLinkExternal href="https://democracycollaborative.org/">
              <DCLogo />
            </BoxLinkExternal>
            <BoxLinkExternal href="https://www.globaljustice.org.uk/">
              <GJNLogo />
            </BoxLinkExternal>
            <BoxLinkExternal href="https://waronwant.org/">
              <WOWLogo />
            </BoxLinkExternal>
            <BoxLinkExternal href="https://autonomy.work/">
              <AutonomyLogo />
            </BoxLinkExternal>
            <BoxLinkExternal href="https://common-wealth.co.uk">
              <CommonwealthLogo />
            </BoxLinkExternal>
            <BoxLinkExternal href="https://www.rosalux.de/en/">
              <RosaLogo />
            </BoxLinkExternal>
            <BoxLinkExternal href="https://iwgb.org.uk/">
              <IWGBLogo />
            </BoxLinkExternal>
          </PartnerGrid>
        </Rows>
        <Rows spacing={2}>
          <Heading level={2} variant="headingSmall">
            Media & Publishing Partners
          </Heading>
          <PartnerGrid gap={3} columnSize={80} maxColumnSize={150}>
            <BoxLinkExternal href="https://novaramedia.com/">
              <NMLogo />
            </BoxLinkExternal>
            <BoxLinkExternal href="https://www.plutobooks.com/">
              <PlutoLogo />
            </BoxLinkExternal>
            <BoxLinkExternal href="https://www.versobooks.com/">
              <VersoLogo />
            </BoxLinkExternal>
          </PartnerGrid>
        </Rows>
      </Rows>
      <ContentSmall>More partners to be announced soon…</ContentSmall>
    </Section>
    <Section bg="bg" color="content">
      <Box height="100px" />
      <Columns alignItems="flex-end" justifyContent="space-between">
        <Rows spacing={3}>
          <ContentSmall>
            <Rows>
              <LinkInternal to="/about">About TWT</LinkInternal>
              <ScrollLink path="/" id="faqs">
                FAQs
              </ScrollLink>
              <LinkInternal to="/privacy-policy">Privacy Policy</LinkInternal>
            </Rows>
          </ContentSmall>
          <ContentSmall>© The World Transformed Ltd</ContentSmall>
          <Columns spacing={2}>
            <LinkExternal href="https://twitter.com/TWT_NOW">
              <TwitterIcon />
            </LinkExternal>
            <LinkExternal href="https://www.facebook.com/TWTNow/">
              <FacebookIcon />
            </LinkExternal>
          </Columns>
        </Rows>
        <Logo fill="bgAlt" />
      </Columns>
    </Section>
  </ThemeProvider>
))
